import { AppButton, AppTypography } from 'src/components';
import { MenuColumn } from './column';
import HubspotContactForm from 'src/components/forms/HubspotContactForm';
import { useToggle } from 'src/hooks/useToggle';
import { contactFormConfig } from 'src/components/forms/hubspot-config';
import { TopNavigationItems } from 'src/layouts/dashboard/navbar/NavConfig';

//
//

const contactUsData = [
  {
    code: TopNavigationItems.offsets,
    title: 'Can’t find a project that fits your business?',
    subtitle:
      'We choose projects that deliver real impact. If you have one in mind or need something specific, we’d love to help.',
  },
  {
    code: TopNavigationItems.programmes,
    title: 'Need help getting set up?',
    subtitle:
      'CarbonClick offers a range of tools to help your customers reduce or offset their emissions – from calculators and reduction tips to fully integrated offsetting experiences. We can help you design a programme that fits your business.',
  },
];

export const ContactUs: React.FC<{ name: string }> = ({ name }) => {
  const toggle = useToggle();
  const data = contactUsData?.find((item) => item?.code === name);

  if (!data) return null;

  return (
    <>
      <MenuColumn showBackground gap={2}>
        <AppTypography fontWeight="bold" variant="body2">
          {data?.title}
        </AppTypography>
        <AppTypography variant="body2">{data?.subtitle}</AppTypography>
        <AppButton variant="contained" color="secondary" sx={{ mr: 'auto' }} onClick={toggle.on}>
          Contact our team
        </AppButton>
      </MenuColumn>

      {toggle.value && (
        <HubspotContactForm
          isModalOpen={toggle.value}
          setIsModalOpen={toggle.setValue}
          region={contactFormConfig.region}
          portalId={contactFormConfig.portalId}
          formId={contactFormConfig.formId}
        />
      )}
    </>
  );
};
